import store from '@/store';
import { showTextModal } from '@/common/utils/ModalState';

// 260902 교회 채널 온라인 추모관 오픈 — flag off면 준비중 모달 + 차단(rule 55, fail-closed).
//   햄버거 진입점 v-if 만으로는 딥링크·뒤로가기로 뚫리므로 라우트 가드를 짝으로 건다.
//   ⚠️ force: true 필수 — 없으면 이미 조회된 flags 캐시에 걸려(common/actions.js) 운영 토글이
//   세션을 새로 열기 전까지 반영되지 않는다(= 롤백 UPDATE 한 줄이 안 먹는다).
const requireMemorialChurchFlag = async (to, from) => {
  await store.dispatch('common/fetchFeatureFlags', { force: true });
  const flags = store.getters['common/getFeatureFlags'];
  if (!flags?.memorialChurchEnabled) {
    showTextModal('준비중입니다.', '확인');
    return from?.name ? false : '/intro';
  }
};

export default [
  {
    path: '/cry',
    component: () => import('@/views/cry/CryMain.vue'),
    meta: {
      isHeader: false,
      isBack: false,
      isNav: true,
      titleName: ''
    }
  },
  {
    path: '/cry/search',
    component: () => import('@/views/cry/search/CrySearch.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isHome: true,
      isBack: true,
      titleName: 'Cry Together 검색'
    }
  },
  {
    path: '/cry/memorial/menu',
    component: () => import('@/views/cry/memorial/MemorialMenu.vue'),
    beforeEnter: requireMemorialChurchFlag,
    meta: {
      isHeader: false,
      isNav: true,
      isHome: true,
      isBack: true,
      titleName: '추모관 선택'
    }
  },
  {
    // 260904 대표 컨펌 — '온라인 추모관'을 누르면 교회 목록에서 교회를 고른 뒤 그 교회 추모관(search)으로 간다.
    //   QR 랜딩 타일·햄버거 두 진입점이 다 여기로 온다. 같은 flag 가드라 롤백 한 줄이 이 화면도 같이 닫는다.
    path: '/cry/memorial/churches',
    component: () => import('@/views/cry/memorial/MemorialChurchList.vue'),
    beforeEnter: requireMemorialChurchFlag,
    meta: {
      isHeader: true,
      isNav: true,
      isHome: true,
      isBack: true,
      titleName: '온라인 추모관'
    }
  },
  {
    // 260903 교회 성도 코드 입력. 같은 flag 가드를 붙여야 롤백(tblFeatureFlag UPDATE 한 줄)이
    //   메뉴·검색·코드 입력 셋을 동시에 닫는다 — 하나만 빠지면 딥링크로 열린 채 남는다.
    path: '/cry/memorial/code',
    component: () => import('@/views/cry/memorial/MemorialChurchCode.vue'),
    beforeEnter: requireMemorialChurchFlag,
    meta: {
      isHeader: true,
      isNav: false,
      isHome: true,
      isBack: true,
      titleName: '교회 성도 코드'
    }
  },
  {
    path: '/cry/memorial/search',
    component: () => import('@/views/cry/memorial/MemorialSearch.vue'),
    beforeEnter: requireMemorialChurchFlag,
    meta: {
      isHeader: true,
      isNav: true,
      isHome: true,
      isBack: true,
      titleName: ''
    }
  },
  {
    path: '/cry/funeral/search',
    component: () => import('@/views/cry/funeral/FuneralSearch.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isHome: true,
      isBack: true,
      titleName: '온라인 장례식장 검색'
    }
  },

  {
    path: '/cry/preview',
    component: () => import('@/views/memorial/register/CryGalleryPreView.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isHome: true,
      isBack: true,
      titleName: '미리보기'
    }
  }
];
